import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 border-t border-background-700/50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-950">
                  <i className="ri-movie-2-line"></i>
                </div>
                <span className="text-lg font-heading font-bold text-foreground-50">天美影视</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                天美影视电影大全，提供最新最全的高清电影资源。不缓冲流畅追大片，免费在线看电影，尽在天美影视。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">
                <a href="#categories">热门分类</a>
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/category/dongzuo" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">动作片</Link>
                </li>
                <li>
                  <Link to="/category/xiju" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">喜剧片</Link>
                </li>
                <li>
                  <Link to="/category/kehuan" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">科幻片</Link>
                </li>
                <li>
                  <Link to="/category/kongbu" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">恐怖片</Link>
                </li>
                <li>
                  <Link to="/category/donghua" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">动画片</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/category/dongzuo" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">电影分类</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-200 mb-4">联系方式</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-mail-line text-foreground-600"></i>
                  <span>contact@tianmeiying.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-phone-line text-foreground-600"></i>
                  <span>400-888-8888</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-map-pin-line text-foreground-600"></i>
                  <span>北京市朝阳区光华路88号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              &copy; {currentYear} 天美影视 TianMeiYing.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}